import {type SuggestValue, Grid, List, Suggest as BaseSuggest} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ControllerRenderProps} from 'react-hook-form'
import {Controller, useFormContext} from 'react-hook-form'

import {useService} from '../../../../api/address/suggest'
import {useSuggest} from '../../hooks/useSuggest'
import type {Props} from './types'

export function Suggest({name, isSource, coordinates}: Props) {
  const {control, watch, trigger, clearErrors} = useFormContext()
  const {fetchAddressSuggest} = useService()
  const {suggestMode, addressSuggestPlaceholder, updateAddress} = useSuggest()
  /** если использовать значение из field, поле не ре-рендерится при удалении точки */
  const address = watch(name)
  const i18n = useI18n()

  // FIXME: придумать что-то менее костыльное
  const handleBlur = (field: ControllerRenderProps) => {
    // Такой хак нужен для того, чтобы onBlur срабатывал после выбора адреса из списка
    // Так как в этом случае сначала срабатывает onChange, а потом onBlur
    // Список адресов находится вне input и поэтому onBlur срабатывает раньше, чем выбор адреса
    setTimeout(async () => {
      await trigger(field.name)
      field.onBlur()
    }, 500)
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({field, fieldState}) => {
        return (
          <BaseSuggest
            key={suggestMode}
            currentMode={suggestMode}
            defaultText={address?.title}
            error={!!fieldState.error?.title}
            fetchSuggest={fetchAddressSuggest}
            helperText={fieldState.error?.title?.message}
            location={coordinates}
            name={field.name}
            noItemsText={i18n('bdui.pickup_points.suggest.no_results', 'Ничего не найдено')}
            onBlur={() => {
              handleBlur(field)
            }}
            onChange={suggestValue => {
              if (suggestValue) {
                updateAddress({name, suggestValue, onChange: field.onChange})
                clearErrors(field.name)
              } else if (!isSource) {
                updateAddress({name, onChange: field.onChange})
              }
            }}
            placeholder={addressSuggestPlaceholder}
            pointType={isSource ? 'a' : 'b'}
            portal={false}
            renderItem={renderItem}
            resetInputOnBlur={isSource || !address?.title}
          />
        )
      }}
    />
  )
}

function renderItem(point: SuggestValue) {
  return (
    <Grid alignItems="center" justify="space-between" container>
      <Grid item>
        <Grid size="s" container>
          <Grid item xs>
            <List.Label variant="body2">{point.title}</List.Label>
            <List.Description color="minor" variant="caption1">
              {point.subtitle}
            </List.Description>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <List.Description color="minor" variant="caption1">
          {point.distance}
        </List.Description>
      </Grid>
    </Grid>
  )
}
